import DESIGN_TYPES from "@/lib/types"
import { FRAGMENTS as COMMON_FRAGMENTS, TYPES as COMMON_TYPES } from "@repo/ui/lib"

const BREADCRUMBS_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        slug
    }
    ... on ${DESIGN_TYPES.PAGES.ALL_PROJECTS_PAGE} {
        slug
    }
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PROJECT} {
        slug
    }				
    ... on ${DESIGN_TYPES.PAGES.SINGLE_HOW_WE_WORK_PAGE_NEW} {
        slug
    }
`
const BREADCRUMBS_FRAGMENT = COMMON_FRAGMENTS.BREADCRUMBS_FRAGMENT_FUNCTION([BREADCRUMBS_LINKS_QUERY])

const CHECK_OTHERS_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        slug
        name
    }
    ... on ${DESIGN_TYPES.PAGES.ALL_PROJECTS_PAGE} {
        slug
        name
    }
`
const CHECK_OTHERS_FRAGMENT = COMMON_FRAGMENTS.CHECK_OTHERS_MODULE_FRAGMENT_FUNCTION([CHECK_OTHERS_LINKS_QUERY])

const STICKY_HEADING_MODULES_QUERY = `
    ... on ${COMMON_TYPES.SINGLE_ASSET} {
        id
    }
    ... on ${COMMON_TYPES.SOCIAL_MEDIA} {
        id
    }
    ... on ${COMMON_TYPES.FAQ} {
        id
    }
`
const STICKY_HEADING_FRAGMENT = COMMON_FRAGMENTS.STICKY_HEADING_FRAGMENT_FUNCTION([STICKY_HEADING_MODULES_QUERY])

const DESCRIPTION_LOGO_PLEO_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        slug
    }
`
const DESCRIPTION_LOGO_PLEO_FRAGMENT = COMMON_FRAGMENTS.DESCRIPTION_LOGO_PLEO_FRAGMENT_FUNCTION([DESCRIPTION_LOGO_PLEO_LINKS_QUERY])

const BLOB_SLOGAN_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.ALL_PROJECTS_PAGE} {
        __typename
        slug
    }
    ... on ${COMMON_TYPES.PAGES.SERVICE_PAGE_RECORD} {
        __typename
        slug
    }
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        __typename
        slug
    }
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PROJECT} {
        __typename
        slug
    }
`
const BLOB_SLOGAN_FRAGMENT = COMMON_FRAGMENTS.BLOB_SLOGAN_FRAGMENT_FUNCTION([BLOB_SLOGAN_LINKS_QUERY])

const FEATURED_PROJECTS_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.ALL_PROJECTS_PAGE} {
        slug
    }
`
const FEATURED_PROJECTS_GRID_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PROJECT} {
            __typename
            id
            name
            slug
            description
            highlight
            projectColor {
                hex
            }
            project
            projectCategories {
                projectCategory
                projectCategoryId
            }
            projectServiceRange {
                serviceName
            }
            year
            ${COMMON_FRAGMENTS.THEME_FRAGMENT}
            coverPortrait {
                ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
            }
            coverLandscape {
                ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
            }
            video {
                ${COMMON_FRAGMENTS.VIDEO_FRAGMENT}
            }
            description
            bannerWhiteLogo
            bannerWhiteMenu
        }
`
const FEATURED_PROJECTS_FRAGMENT = COMMON_FRAGMENTS.FEATURED_PROJECTS_FRAGMENT_FUNCTION(
	[FEATURED_PROJECTS_LINKS_QUERY],
	[FEATURED_PROJECTS_GRID_QUERY],
)

const NEWS_THUMBNAILS_BUTTON_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        slug
    }
`
const NEWS_THUMBNAILS_FRAGMENT = COMMON_FRAGMENTS.NEWS_THUMBNAILS_FRAGMENT_FUNCTION([NEWS_THUMBNAILS_BUTTON_LINKS_QUERY])

const HOW_WE_CREATE_STORY_BUTTON_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        slug
    }
`

const HOW_WE_CREATE_STORY_LINKS_QUERY = `
    __typename
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        slug
    }
`
const HOW_WE_CREATE_STORY_FRAGMENT = COMMON_FRAGMENTS.HOW_WE_CREATE_STORY_FRAGMENT_FUNCTION(
	[HOW_WE_CREATE_STORY_BUTTON_LINKS_QUERY],
	[HOW_WE_CREATE_STORY_LINKS_QUERY],
)

const SOCIAL_MEDIA_FRAGMENT = COMMON_FRAGMENTS.SOCIAL_MEDIA_FRAGMENT
const FAQ_FRAGMENT = COMMON_FRAGMENTS.FAQ_FRAGMENT
const ABOUT_TEAM_FRAGMENT = COMMON_FRAGMENTS.ABOUT_TEAM_FRAGMENT
const SINGLE_ASSET_FRAGMENT = COMMON_FRAGMENTS.SINGLE_ASSET_FRAGMENT
const HEADER_AND_DESCRIPTION_FRAGMENT = COMMON_FRAGMENTS.HEADER_AND_DESCRIPTION_FRAGMENT

const TILES_WITH_DESCRIPTION_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_HOW_WE_WORK_PAGE_NEW} {
        slug
    }
`
const TILES_WITH_DESCRIPTION_FRAGMENT = COMMON_FRAGMENTS.TILES_WITH_DESCRIPTION_FRAGMENT_FUNCTION([TILES_WITH_DESCRIPTION_LINKS_QUERY])

const TILES_MODULE_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        id
        slug
    }
`
const TILES_MODULE_FRAGMENT = COMMON_FRAGMENTS.TILES_MODULE_FRAGMENT_FUNCTION([TILES_MODULE_LINKS_QUERY])

const PROJECTS_GRID_BUTTON_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PROJECT} {
        __typename
        id
        name
        slug
        description
        highlight
        projectColor {
            hex
        }
        project
        projectCategories {
            projectCategory
            projectCategoryId
        }
        projectServiceRange {
            serviceName
        }
        year
        ${COMMON_FRAGMENTS.THEME_FRAGMENT}
        coverPortrait {
           ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
        }
        coverLandscape {
           ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
        }
        video {
            ${COMMON_FRAGMENTS.VIDEO_FRAGMENT}
        }
        description
        bannerWhiteLogo
        bannerWhiteMenu
    }
`

const PROJECTS_GRID_FRAGMENT = COMMON_FRAGMENTS.PROJECTS_GRID_FRAGMENT_FUNCTION([PROJECTS_GRID_BUTTON_LINKS_QUERY])

const DESCRIPTION_BUTTON_LINKS_QUERY = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PAGE} {
        slug
    }
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PROJECT} {
        slug
    }				 
`

const DESCRIPTION_SLOGAN_FRAGMENT = `
    descriptionSlogan {
        description
        slogan1
        slogan2
        ${COMMON_FRAGMENTS.LINK_BUTTON_FRAGMENT_FUNCTION([DESCRIPTION_BUTTON_LINKS_QUERY])}
    }
`
const SINGLE_PROJECT_FRAGMENT = `
    ... on ${DESIGN_TYPES.PAGES.SINGLE_PROJECT}  {
            id
            name
            description
            slug
            highlight
            projectColor {
                hex
            }
            project
            projectCategories {
                projectCategory
                projectCategoryId
            }
            projectServiceRange {
                serviceName
            }
            year
            ${COMMON_FRAGMENTS.THEME_FRAGMENT}
            coverPortrait {
                ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
            }
            coverLandscape {
                ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
            }
            video {
                url
                width
                height
                mimeType
            }
            description
            bannerWhiteLogo
            bannerWhiteMenu
    }
`

const NAVIGATION_ELEVATOR_FRAGMENT = `
    projectNavigationElevator {
        link {
            __typename
            ... on ${COMMON_TYPES.PROJECT_RANGE} {
                id
            }
            ... on ${COMMON_TYPES.TECHNOLOGIES_TABLE} {
                id
            }
            ... on ${COMMON_TYPES.SINGLE_ASSET} {
                id
            }
            ... on ${COMMON_TYPES.ASSET_WITH_HEADER} {
                id
            }
            ... on ${COMMON_TYPES.HEADER_AND_DESCRIPTION} {
                id
            }
            ... on ${COMMON_TYPES.PINNED_TEXT_WITH_IMAGE} {
                id
            }
            ... on ${COMMON_TYPES.TILES_MODULE} {
                id
            }
            ... on ${COMMON_TYPES.PROJECT_SLIDER} {
                id
            }
            ... on ${COMMON_TYPES.PROJECT_SCOPE} {
                id
            }
            ... on ${COMMON_TYPES.TEXT_MODULE} {
                id
            }
            ... on ${COMMON_TYPES.CHECK_OTHERS} {
                id
            }
            
        }
        elevatorText
    }
`

const FRAGMENTS = Object.freeze({
	CHECK_OTHERS_FRAGMENT,
	STICKY_HEADING_FRAGMENT,
	SOCIAL_MEDIA_FRAGMENT,
	SINGLE_ASSET_FRAGMENT,
	DESCRIPTION_LOGO_PLEO_FRAGMENT,
	BLOB_SLOGAN_FRAGMENT,
	FEATURED_PROJECTS_FRAGMENT,
	NEWS_THUMBNAILS_FRAGMENT,
	HOW_WE_CREATE_STORY_FRAGMENT,
	BREADCRUMBS_FRAGMENT,
	ABOUT_TEAM_FRAGMENT,
	FAQ_FRAGMENT,
	TILES_WITH_DESCRIPTION_FRAGMENT,
	TILES_MODULE_FRAGMENT,
	PROJECTS_GRID_FRAGMENT,
	DESCRIPTION_SLOGAN_FRAGMENT,
	SINGLE_PROJECT_FRAGMENT,
	NAVIGATION_ELEVATOR_FRAGMENT,
	HEADER_AND_DESCRIPTION_FRAGMENT,
})

export default FRAGMENTS
